import styled from '../../../../../styles/styledComponents/themeComponents';

export const PeriodPickerStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .picker-row {
    display: flex;
    align-items: center;
    gap: 12px;

    .picker-label {
      min-width: 48px;
      font-size: 13px;
      color: #555;
      font-weight: 500;
    }

    .ant-picker {
      width: 240px;
    }
  }

  .checkbox-row {
    padding-left: 60px;
    font-size: 13px;
  }
`;
